import Box from '@mui/material/Box';
import { type Theme } from '@mui/material/styles';
import React from 'react';
import { l } from 'app/blocks/common/codes';
import loadingFilledIcon from './icons/loading-filled.svg';

export function StaticSearchLoadingPanel() {
    return (
        <Box
            className="StaticSearch-loading"
            sx={theme => ({
                alignItems: 'center',
                backgroundColor: (theme.vars || theme).palette.common.white,
                borderBottom: '1px solid #e0e0e0',
                borderTop: '1px solid #e0e0e0',
                boxSizing: 'border-box',
                color: (theme.vars || theme).palette.text.primary,
                display: 'flex',
                gap: '8px',
                minHeight: '40px',
                padding: '8px 16px',
                width: '100%',
            })}
        >
            <Box
                alt=""
                aria-hidden
                className="StaticSearch-loading-icon"
                component="img"
                decoding="async"
                src={loadingFilledIcon}
                sx={{
                    animation: 'StaticSearch-loading-spin 0.8s linear infinite',
                    display: 'block',
                    flexShrink: 0,
                    height: 24,
                    width: 24,
                }}
            />
            <Box
                className="StaticSearch-loading-message"
                component="p"
                sx={theme => ({
                    color: 'inherit',
                    flex: 1,
                    fontFamily: (theme as Theme).typography.fontFamily,
                    fontSize: '1rem',
                    letterSpacing: '0.15px',
                    lineHeight: 1.5,
                    margin: 0,
                    minWidth: 0,
                    whiteSpace: 'normal',
                })}
            >
                {l('SEARCH_CODES.STATIC.STATES.LOADING')}
            </Box>
        </Box>
    );
}

export default StaticSearchLoadingPanel;
